export default __webpack_public_path__ + "static/media/phase3.810a246e.svg";